





























































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import CHeader from "@/components/CHeader.vue";
import CFooter from "@/components/CFooter.vue";
import moment from "moment";
import CheckRestaurantLogin from "@/utils/CheckRestaurantLogin";
import AuthModule from "@/store/auth";
import OrderModule from "@/store/order";
import OrderList from "@/components/OrderList.vue";
import { RestaurantsApi, OrdersApi } from "@/services/api-service";
import RTab from "@/components/RTab.vue";
import { ja } from "vuejs-datepicker/dist/locale";
import Pagination from "@/components/Pagination.vue";
import PaginationModule from "@/store/pagination";
import ModalPaginationModule from "@/store/modalPagination";
import { OrderStatus, SortDirection, OrderType, Order } from "@/api/api";
import { toUpperFirstLetter } from "@/utils/Util";
import { Route } from "vue-router";

Component.registerHooks(["beforeRouteLeave"]);
// import io from "socket.io-client";

@Component({
  components: {
    CHeader,
    CFooter,
    OrderList,
    RTab,
    Pagination,
  },
})
export default class ROrders extends CheckRestaurantLogin {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected async beforeRouteLeave(to: Route, from: Route, next: any) {
    if (this.modalOrdersInterval !== null) {
      clearInterval(this.modalOrdersInterval);
    }
    next();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private formattedOrders: any = {};

  private get moment() {
    return moment;
  }

  private get orders() {
    return OrderModule.orders;
  }

  private get modalOrders() {
    return OrderModule.modalOrders;
  }

  private get modalOrdersQuantity() {
    return OrderModule.modalOrdersQuantity;
  }

  private get modalPageNum() {
    return ModalPaginationModule.pageNum;
  }

  private get me() {
    return AuthModule.me;
  }

  private get OrderStatus() {
    return OrderStatus;
  }

  private get isNotice() {
    return OrderModule.isNotice ? OrderModule.isNotice : false;
  }

  private get isPush() {
    return OrderModule.isPush ? OrderModule.isPush : false;
  }

  private get isNewOrdersModal() {
    return OrderModule.isNewOrdersModal ? OrderModule.isNewOrdersModal : false;
  }

  private get ja() {
    return ja;
  }

  private get date() {
    return this?.$route?.query?.date ? String(this.$route.query.date) : this.currentDate;
  }

  private modalOrdersInterval: null | NodeJS.Timeout = null;

  private created() {
    // 新規注文定期確認
    if (this.modalOrdersInterval === null) {
      this.modalOrdersInterval = setInterval(() => {
        if (this.$route?.name === "ROrders" || this.$route?.name === "ROrdersWithPageNum") {
          this.getModalOrders();
        }
      }, 5000);
    }
  }

  // private created() {
  //   this.initWS();
  // }

  // @Watch("me")
  // private initWS() {
  //   const socket = io("ws://127.0.0.1:4000");
  //   console.log("socket", socket);
  //   console.log("this.me", this.me?.uuid);

  //   // socket.emit("join", {
  //   //   room: this.me?.uuid,
  //   //   iam: "front",
  //   // });
  //   socket.emit("emit_from_client", { msg: "im front" });

  //   socket.on("emit_from_server", (data: string) => console.log(`${JSON.stringify(data)}from emit from server`));
  //   socket.on("receive_order", (data: string) => console.log(JSON.stringify(data)));
  // }

  private currentModalOrdersQuantity = 0;

  private currentDate = new Date();

  private currentOrder: Order | null = null;

  private windowWidth: number | null = null;

  private muted = true;

  private toggleMute() {
    this.muted = !this.muted;
    const audioElement = this.$refs.silent as HTMLAudioElement;
    // 切り替え時にsilent音声を流すことで以降の自動pinpon再生を有効化
    audioElement.play();
  }

  private playPinpon() {
    const audioElement = this.$refs.pinpon as HTMLAudioElement;
    audioElement.play();
  }

  // 新規注文が増えたときの処理
  @Watch("modalOrdersQuantity")
  private noticeAction() {
    if (this.modalOrdersQuantity > this.currentModalOrdersQuantity) {
      if (!this.muted) {
        this.playPinpon();
      }
    }
    this.currentModalOrdersQuantity = this.modalOrdersQuantity;
  }

  private displayStatus(status: OrderStatus) {
    if (status === OrderStatus.Checking) {
      return "未確認";
    }
    if (status === OrderStatus.Processing) {
      return "受付中";
    }
    if (status === OrderStatus.Completed) {
      return "完了";
    }
    return "";
  }

  private async changeStatus(status: OrderStatus) {
    if (!this.currentOrder?.uuid) {
      return;
    }
    try {
      await OrdersApi.instance.patchOrder(this.currentOrder.uuid, {
        orderStatus: status,
      });
      await this.getModalOrders();
      this.closeModal(`operation${toUpperFirstLetter(status)}`);
    } catch (err) {
      console.log(err);
    }
  }

  private displayOrderType(orderType: OrderType) {
    if (orderType === OrderType.Takeout) {
      return "テイクアウト";
    }
    if (orderType === OrderType.Delivery) {
      return "デリバリー";
    }
    return "";
  }

  private showModalOrders(name: string, order: Order) {
    OrderModule.commitIsNewOrdersModal(true);
    ModalPaginationModule.commitPageNum(1);
    this.currentOrder = order;
    this.$modal.show(`${name}`);
    this.getModalOrders();
  }

  private closeModal(name: string) {
    if (name === "modal-orders") {
      OrderModule.commitIsNewOrdersModal(false);
    }
    this.currentOrder = null;
    this.$modal.hide(name);
  }

  private dateFormatter(date: Date) {
    return moment(date).format("YYYY年MM月DD日");
  }

  private mounted() {
    window.addEventListener("resize", this.calcWindowWidth);
    this.calcWindowWidth();
    this.setDate();
    OrderModule.commitIsNewOrdersModal(false);
    OrderModule.commitIsNotice(false);
  }

  private beforeDestroy() {
    window.removeEventListener("resize", this.calcWindowWidth);
    this.calcWindowWidth();
  }

  private calcWindowWidth() {
    this.windowWidth = window.innerWidth;
  }

  @Watch("me")
  @Watch("$route", { deep: true })
  private async getOrders() {
    const limit = 8;
    const pageNum = this.$route.params?.pageNum ? Number(this.$route.params.pageNum) : 0;

    if (!this.me?.uuid || typeof this.me?.uuid !== "string") {
      return;
    }
    try {
      // eslint-disable-next-line prettier/prettier
      const ordersRes = await RestaurantsApi.instance.getOrdersByRestaurantUuid(
        this.me?.uuid,
        limit,
        pageNum === 0 ? 0 : (pageNum - 1) * limit,
        SortDirection.Desc,
        "createdAt",
        this.currentDate.toISOString()
      );
      // eslint-disable-next-line prettier/prettier
      if (!ordersRes.data.data?.items || !(ordersRes.data.data.items.length > 0)) {
        OrderModule.commitOrders([]);
        PaginationModule.commitTotal(0);
        PaginationModule.commitLimit(limit);
        this.$router.push({ name: "ROrders" });
        return;
      }
      OrderModule.commitOrders(ordersRes.data.data.items);
      PaginationModule.commitTotal(Number(ordersRes.data.data.total));
      PaginationModule.commitLimit(limit);
    } catch (err) {
      console.log(err);
    }
  }

  private pushNotice() {
    OrderModule.commitIsPush(true);
    setTimeout(() => {
      OrderModule.commitIsPush(false);
    }, 5000);
  }

  private addActive() {
    OrderModule.commitIsNotice(true);
    this.getModalOrders();
  }

  private removeActive() {
    OrderModule.commitIsNotice(false);
  }

  @Watch("currentDate")
  private setDate() {
    OrderModule.commitCurrentDate(this.currentDate);
    OrderModule.commitOrders([]);
    this.getOrders();
  }

  @Watch("modalOrders")
  @Watch("$route", { deep: true })
  private formatOrders() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const formattedOrders: any = {};

    this.modalOrders.forEach(order => {
      const date = order.deliveryDate
        ? moment(order.deliveryDate).format("YYYY年MM月DD日")
        : moment().format("YYYY年MM月DD日");
      if (!formattedOrders[String(date)]) {
        // eslint-disable-next-line no-unused-expressions
        formattedOrders[String(date)] = { date, orders: [order] };
      } else {
        formattedOrders[String(date)].orders.push(order);
      }
    });
    this.formattedOrders = formattedOrders;
  }

  @Watch("modalPageNum")
  @Watch("orders")
  private async getModalOrders() {
    const limit = 8;
    const pageNum = this.modalPageNum ? Number(this.modalPageNum) : 0;
    if (!this.me?.uuid || typeof this.me?.uuid !== "string") {
      return;
    }
    try {
      // eslint-disable-next-line prettier/prettier
      const ordersRes = await RestaurantsApi.instance.getOrdersByRestaurantUuid(
        this.me?.uuid,
        limit,
        pageNum === 0 ? 0 : (pageNum - 1) * limit,
        SortDirection.Desc,
        "deliveryDate",
        undefined,
        OrderStatus.Checking
      );
      // eslint-disable-next-line prettier/prettier
      if (!ordersRes.data.data?.items || !(ordersRes.data.data.items.length > 0)) {
        OrderModule.commitModalOrders([]);
        ModalPaginationModule.commitTotal(0);
        ModalPaginationModule.commitLimit(limit);
        this.$router.push({ name: "ROrders" });
        return;
      }
      OrderModule.commitModalOrders([]);
      OrderModule.commitModalOrders(ordersRes.data.data.items);
      ModalPaginationModule.commitTotal(Number(ordersRes.data.data.total));
      ModalPaginationModule.commitLimit(limit);
    } catch (err) {
      console.log(err);
    }
  }

  @Watch("modalOrders")
  private async getModalOrdersQuantity() {
    if (!this.me?.uuid || typeof this.me?.uuid !== "string") {
      return;
    }
    try {
      // eslint-disable-next-line prettier/prettier
      const ordersRes = await RestaurantsApi.instance.getOrdersByRestaurantUuid(
        this.me?.uuid,
        undefined,
        undefined,
        undefined,
        "createdAt",
        undefined,
        OrderStatus.Checking
      );
      // eslint-disable-next-line prettier/prettier
      if (!ordersRes.data.data?.items || !(ordersRes.data.data.items.length > 0)) {
        OrderModule.commitModalOrdersQuantity([]);
        return;
      }
      OrderModule.commitModalOrdersQuantity(ordersRes.data.data.items);
    } catch (err) {
      console.log(err);
    }
  }
}
